import { render, staticRenderFns } from "./resultMBTI.vue?vue&type=template&id=099b6270&scoped=true&"
import script from "./resultMBTI.vue?vue&type=script&lang=js&"
export * from "./resultMBTI.vue?vue&type=script&lang=js&"
import style0 from "./resultMBTI.vue?vue&type=style&index=0&id=099b6270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b6270",
  null
  
)

export default component.exports